import type { FaireProductEntity } from "../../entity_types/product";

export const p_36j2ps3emg: FaireProductEntity = {
  token: "p_36j2ps3emg",
  type: "product",
  name: "18K Gold PVD Stainless Steel Dainty Curb and Paperclip Layered Chain Necklace",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/312a172f9d9991264a7070f814eac3ecc43bcc8216948ba19ce1c0131170610c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/49e86f98053e78a8f89d3ccc67b13f42eadd757ffca4f959c794c9ffcd34e681.jpeg",
    "https://cdn.faire.com/fastly/ddaf3d9a472a37b0f2d265a563d87abf6a3fe5fa8c0ac11646f7b1855ecfe1e1.jpeg",
    "https://cdn.faire.com/fastly/311f18c9466882e0bf595763e5c74f179ae584038c3b94dba5103c62d6bd4e77.jpeg",
  ],
  priceDollars: 7.04,
  description:
    "\nUpgrade your necklace collection with the everyday classic, layered dainty Curb & Paperclip Chain Necklace!\n\nCrafted from high-quality 18K Gold PVD as well as stainless steel, this layered necklace includes a variety of chains to add texture and interest to any outfit. Between this necklace's popular look and classic style, it is sure to be a top seller in any storefront or jewelry collection!\n\n * Waterproof, non-tarnish, hypoallergenic \n * Premium 18K Gold PVD stainless steel \n * Includes 2 chain necklaces combined at the clasp \n * 2\" chain extender allows for a variety of fits \n * Add a jump ring and charm to turn this necklace into a layered charm necklace \nExplore the Paperclip Collection to turn this style into a complete collection!",
  tags: [],
  msrpDollars: 63.35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:44.316Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
